const moduleName = "pembatalanTopupDepositModule";

// filter
const pagination = () => ({
  limit: 20,
  offset: 0,
  length: 0,
  pageNumber: 0,
});

const search = () => ({
  onSearch: false,
  key: "",
});

const exportKey = {
  tracker: "export:job:pembatalan:topup:deposit",
  job: "perhap_topup_deposit_export",
};

const sorting = [
  {
    label: "Belum dikonfirmasi",
    name: "sorting",
    value: JSON.stringify({
      sortBy: "tipe",
      orderBy: "ASC",
    }),
    id: "sorting-1",
  },
  {
    label: "Sudah dikonfirmasi",
    name: "sorting",
    value: JSON.stringify({
      sortBy: "tipe",
      orderBy: "DESC",
    }),
    id: "sorting-2",
  },
  {
    label: "Permintaan terbaru",
    name: "sorting",
    value: JSON.stringify({
      sortBy: "transaksi",
      orderBy: "DESC",
    }),
    id: "sorting-3",
  },
  {
    label: "Permintaan terlama",
    name: "sorting",
    value: JSON.stringify({
      sortBy: "transaksi",
      orderBy: "ASC",
    }),
    id: "sorting-4",
  },
];

const state = {
  // data
  listTransaksi: [],
  detailTransaksi: {},
  notaTransaksi: {},
  totalData: 0,

  // filter
  pagination: pagination(),
  search: search(),
  onFilter: false,
  sorting: sorting,

  // response status
  response: {},
  useToastSuccess: false,

  exportProgress: {
    processed: 0,
    total: 0,
  },
  exportData: [],
  exportDataLength: 0,
  exporting: false,
  minimizedExport: false,
  multipleExport: false,
  fetching: false,
  loadMore: false,

  scrollPosition: 0,
};

export { state as default, pagination, search, sorting, moduleName, exportKey };
